import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const Wrapper = styled.div`
  width: 92%;
  margin-bottom: 16px;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
  }
`

export const Label = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: #353535;
  margin: 0 0 8px;
`

export const Card = styled.div`
  background: #e7eff2;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  @media (max-width: ${breakpoints.m}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  @media (max-width: ${breakpoints.l}px) {
    gap: 16px;
  }
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    align-items: flex-start;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 120px;
  height: 97px;
  border-radius: 7px;
  overflow: hidden;
  flex-shrink: 0;
  background: #ffffff;
  .gatsby-image-wrapper {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
  }
  .gatsby-image-wrapper img {
    object-fit: cover;
  }
  > img {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`

export const DiscountBadge = styled.span`
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 2;
  background: #fe987e;
  color: #353535;
  border-radius: 9999px;
  font-size: 12px;
  line-height: 1;
  padding: 4px 6px;
`

export const TextInfo = styled.div`
  min-width: 210px;
  @media (max-width: ${breakpoints.m}px) {
    min-width: 0;
  }
`

export const Title = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  margin: 0;
  color: #353535;
`

export const Subtitle = styled.p`
  font-size: 12px;
  line-height: 18px;
  margin: 0;
  color: #606060;
  @media (max-width: ${breakpoints.m}px) {
    margin: 4px 0;
  }
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  min-width: 0;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`

export const StyleButtonsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`

export const ColorRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
  @media (max-width: ${breakpoints.m}px) {
    margin-left: 0;
  }
`

export const StyleButton = styled.button`
  border: ${(props) => (!props.selected ? '1px solid #0f4f67' : 'none')};
  background: ${(props) => (props.selected ? '#0A4659' : '#ffffff')};
  color: ${(props) => (props.selected ? '#ffffff' : '#0A4659')};
  border-radius: 9999px;
  padding: 4px 14px;
  font-family: 'MatterRegular';
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
`

export const Swatches = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 0;
`

export const SwatchButton = styled.button`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: ${(props) => (props.selected ? '1px solid #EFEFEF' : 'none')};
  box-shadow: ${(props) => (props.selected ? '0 0 0 2px #82D7DD' : 'none')};
  cursor: pointer;
  background: ${(props) => props.background};
  padding: 0;
`

export const ColorName = styled.span`
  font-family: 'MatterRegular';
  font-size: 12px;
  color: #4b4b4b;
`

export const CtaCol = styled.div`
  min-width: 165px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    align-items: flex-start;
    > button {
      width: 100%;
      max-width: none;
    }
  }
`

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  ${({ hideOnDesktop }) => hideOnDesktop && 'display: none;'}
  @media (max-width: ${breakpoints.m}px) {
    ${({ hideOnDesktop }) => hideOnDesktop && 'display: flex;'}
    ${({ hideOnMobile }) => hideOnMobile && 'display: none;'}
  }
`

export const OriginalPrice = styled.span`
  font-size: 14px;
  line-height: 21px;
  color: #606060;
  text-decoration: line-through;
`

export const DiscountedPrice = styled.span`
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: #fd653f;
`
